import { render, staticRenderFns } from "./ChoiceField.vue?vue&type=template&id=29d66056"
import script from "./ChoiceField.vue?vue&type=script&lang=ts"
export * from "./ChoiceField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports